<template>
    <div>
        <a-table :columns="columns" :data-source="dataTable.slice().reverse()">
            <template slot="updated_at" slot-scope="text, record">
                {{ moment(record.created_at).format("DD / MM / YYYY") + ' '+
                    moment(record.created_at).format("LTS") 
                }}
            </template>
            <template slot="action" slot-scope="text, record">
                <a-popconfirm title="Are you sure to Delete？" @confirm="removeData(record.id)">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a-button type="danger" icon="delete"></a-button>
                </a-popconfirm>
            </template>
        </a-table>
    </div>
</template>
<script>
const columns = [
    {
        title: 'Update At',
        width: 150,
        dataIndex: "updated_at",
        scopedSlots: { customRender: "updated_at" },
        fixed: "left",
        // className: "center-colum column-header",
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
    },
    {
        title: 'Home Phone',
        dataIndex: 'phone_home',
        key: 'phone_home',
    },
    {
        title: 'Phone',
        dataIndex: 'phone_number',
        key: 'phone_number',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
    },
    {
        title: 'IG',
        dataIndex: 'social_instagram',
        key: 'social_instagram',
    },
    {
        title: 'Facebook',
        dataIndex: 'social_facebook',
        key: 'social_facebook',
    },
    {
        title: 'Action',
        key: 'action',
        scopedSlots: { customRender: "action" },
    }
];

export default {
    props: {
        dataTable: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            columns: columns,
        };
    },
    methods: {
        async removeData(idDel) {
            try {
                const res = await this.$http.delete(
                    `/student_affair/alumni-profile-contact/${idDel}/`
                );
                if (res.status === 204) {
                    // const indexDel = this.data.findIndex(
                    //     (itemDel) => itemDel.id === idDel
                    // );
                    // this.data.splice(indexDel, 1);
                    // //console.log(this.data)
                    // this.$getProfileMain()
                    this.$emit('deleteID', { dataId: idDel })
                } else {
                    throw { res };
                }
            } catch (error) {
                this.$emit("errorNotification", {
                    errorMsg: error.response.status,
                    urlPath: `/student_affair/alumni-profile-contact/${idDel}/`,
                });
            }
        },
    },
}</script>